import { render, staticRenderFns } from "./UsageExample.vue?vue&type=template&id=c961b300&scoped=true"
import script from "./UsageExample.vue?vue&type=script&lang=js"
export * from "./UsageExample.vue?vue&type=script&lang=js"
import style0 from "./UsageExample.vue?vue&type=style&index=0&id=c961b300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c961b300",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/vercel/path0/components/elements/Heading.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
